/*
 * @Description:
 * @Autor: zwcong
 * @Date: 2022-01-08 16:26:54
 * @LastEditors: zwcong
 * @LastEditTime: 2022-01-08 16:32:17
 */

const state = {
  batchCardInfo: null // 保存批量添加卡，第一步信息
}

// 自定义改变state初始值的方法
const mutations = {
  setBatchCardInfo (state, data) {
    console.log('data', data)
    state.batchCardInfo = data
  }
}

// 自定义触发mutations里函数的方法
const actions = {}

const getters = {
  batchCardInfo: state => state.batchCardInfo
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
